import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, takeUntil } from 'rxjs';

import { PostModel } from '../../sign-up/models/sign-up.model';
import { ApiService } from '../../sign-up/services/api.service';
import { LocaleService } from '../../../locale/locale.service';
import { RoutesEnum } from '../../../locale/routes.enum';
import { TitleService } from "../../../services/title.service";

@Component({
  selector: 'app-lexicon-page',
  templateUrl: './lexicon-page.component.html',
  styleUrls: [
    './styles/lexicon-page.component.scss',
    './styles/lexicon-page-desktop.scss',
    './styles/lexicon-page-tablet.scss',
    './styles/lexicon-page-mobile.scss',
    '../../blog-page/styles/post.scss',
    '../../blog-page/styles/post-info-block.scss',
    '../../blog-page/styles/post-desktop.scss',
    '../../blog-page/styles/post-mobile.scss',
  ]
})
export class LexiconPageComponent implements OnInit, OnDestroy {

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public postData$: BehaviorSubject<PostModel> = new BehaviorSubject<PostModel>({} as PostModel);
  private scrollContainer?: HTMLElement | null;
  public routesEnum: typeof RoutesEnum = RoutesEnum;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private sanitized: DomSanitizer,
    public localeService: LocaleService,
    private router: Router,
    public titleService: TitleService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit() {
    this.route.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const postName: string | null = params.get('postName');
        if (postName) {
          this.getPost(postName)
        }
      });

    this.scrollContainer = this.document.getElementById('main-container');
  }

  public getPost(postName: string): void {
    this.apiService.getLexicon(postName)
      .pipe(takeUntil(this.destroy$))
      .subscribe(post => {
        this.postData$.next(this.preparePostData(post));
        this.titleService.updateMetaTitle(post.seo_title);
        this.titleService.updateMetaDescription(post.meta_description);
      }, error => {
        if (error.status === 404) {
          this.router.navigate([this.localeService.rootRoute + '/404']);
        } else {
          this.router.navigate([this.localeService.rootRoute]);
        }
      });
  }

  public scrollTo(fragment: string): void {
    if (isPlatformBrowser(this.platformId) && !!fragment) {
      const headerElement = document.getElementById('header');
      const id = fragment;
      // @ts-ignore
      const yOffset = headerElement.getBoundingClientRect().height + 20;
      const element: HTMLElement | null = this.document.getElementById(id);

      // @ts-ignore
      const y = element.getBoundingClientRect().top + this.scrollContainer?.scrollTop - yOffset;
      this.scrollContainer?.scrollTo({top: y});
    }
  }

  public preparePostData(post: PostModel): PostModel {
    return {
      ...post,
      createdDate: post.created_at * 1000 // convert to utc format (10 characters in response)
    };
  }

  public getPostMarking(post: any): SafeHtml | null {
    if (!post) { return null ;}
    return this.sanitized.bypassSecurityTrustHtml(post);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
